import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";

import { MENU } from "./menu";
import { MenuItem } from "./menu.model";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/shared/services/auth.service";
import { Helper } from "src/app/core/helpers/helper";

@Component({
  selector: "app-two-column-sidebar",
  templateUrl: "./two-column-sidebar.component.html",
  styleUrls: ["./two-column-sidebar.component.scss"],
  standalone: false
})
export class TwoColumnSidebarComponent implements OnInit {
  twoColumnMenuItems: MenuItem[] = [];
  twoColumnPermissionSubscription: Subscription | undefined;
  twoColumnPermissions: any[] = [];
  twoColumnDefaultMenu = "/";

  @Output() mobileMenuButtonClicked = new EventEmitter();

  constructor(private router: Router, private authService: AuthService, public helper: Helper) {}

  ngOnInit(): void {
    // Menu Items
    this.twoColumnPermissionSubscription = this.authService.authPermission.subscribe((permissions) => {
      this.twoColumnPermissions = permissions;
      this.twoColumnMenuItems = MENU;
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.initActiveMenu();
      }
    });
  }

  /***
   * Activate drop down set
   */
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initActiveMenu();
    }, 0);
  }

  toggleSubItem(item: any): void {
    this.twoColumnMenuItems.forEach((menuItem: any) => {
      if (menuItem.subItems) {
        menuItem.subItems.forEach((subItem: any) => {
          if (subItem === item) {
            menuItem.isCollapsed = !menuItem.isCollapsed;
            subItem.isCollapsed = !subItem.isCollapsed;
          } else {
            subItem.isCollapsed = true;
          }

          this.toggleTwoColumnSubsSubItem(item, subItem, menuItem);
        });
      }
    });
  }

  toggleTwoColumnSubsSubItem(item: any, twoColumnSubItem: any, twoColumnMenuItem: any): void {
    if (twoColumnSubItem.subItems) {
      twoColumnSubItem.subItems.forEach((childitem: any) => {
        if (childitem === item) {
          childitem.isCollapsed = !childitem.isCollapsed;
          twoColumnSubItem.isCollapsed = !twoColumnSubItem.isCollapsed;
          twoColumnMenuItem.isCollapsed = !twoColumnMenuItem.isCollapsed;
        } else {
          childitem.isCollapsed = true;
        }

        this.toggleTwoColumnChildItems(item, twoColumnSubItem, childitem, twoColumnMenuItem);
      });
    }
  }

  toggleTwoColumnChildItems(item: any, twoColumnSubItem: any, twoColumnChilditem: any, twoColumnMenuItem: any): void {
    if (twoColumnChilditem.subItems) {
      twoColumnChilditem.subItems.forEach((childrenitem: any) => {
        if (childrenitem === item) {
          childrenitem.isCollapsed = false;
          twoColumnChilditem.isCollapsed = false;
          twoColumnSubItem.isCollapsed = false;
          twoColumnMenuItem.isCollapsed = false;
        } else {
          childrenitem.isCollapsed = true;
        }
      });
    }
  }

  toggleExtraSubItem(event: any): void {
    const isCurrentMenuId = event.target.closest("a.nav-link");
    const isMenu: any = isCurrentMenuId.nextElementSibling;
    if (isMenu.classList.contains("show")) {
      isMenu.classList.remove("show");
      isCurrentMenuId.setAttribute("aria-expanded", "false");
    } else {
      const dropDowns = Array.from(document.querySelectorAll(".extra-sub-menu"));
      dropDowns.forEach((node: any) => {
        node.classList.remove("show");
      });

      const subDropDowns = Array.from(document.querySelectorAll(".menu-dropdown .nav-link"));
      subDropDowns.forEach((submenu: any) => {
        submenu.setAttribute("aria-expanded", "false");
      });

      if (event.target && event.target.nextElementSibling) {
        isCurrentMenuId.setAttribute("aria-expanded", "true");
        event.target.nextElementSibling.classList.toggle("show");
      }
    }
  }

  updateActive(event: any): void {
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link.active"));
      this.removeActivation(items);
    }
    this.activateTwoColumnParentDropdown(event.target);
  }

  // Click wise Parent active class add
  toggleTwoColumnParentItem(event: any): void {
    const isTwoColumnCurrentParentMenuId = event.target.getAttribute("subitems");
    const isTwoColumnParentMenu = document.getElementById(isTwoColumnCurrentParentMenuId) as any;
    const twoColumnParentDropDowns = Array.from(document.querySelectorAll("#navbar-nav .show"));
    twoColumnParentDropDowns.forEach((node: any) => {
      node.classList.remove("show");
    });
    if (isTwoColumnParentMenu) {
      isTwoColumnParentMenu.classList.add("show");
    }

    const twoColumnParentUl = document.getElementById("two-column-menu");
    if (twoColumnParentUl) {
      const twoColumnParentIconItems = Array.from(twoColumnParentUl.getElementsByTagName("a"));
      const twoColumnParentActiveIconItems = twoColumnParentIconItems.filter((x: any) => x.classList.contains("active"));
      twoColumnParentActiveIconItems.forEach((item: any) => {
        item.classList.remove("active");
      });
    }
    event.target.classList.add("active");
    document.body.classList.add("twocolumn-panel");
  }

  toggleTwoColumnItem(event: any): void {
    // show navbar-nav menu on click of icon sidebar menu
    const isTwoColumnCurrentMenuId = event.target.getAttribute("subitems");
    const isTwoColumnMenu = document.getElementById(isTwoColumnCurrentMenuId) as any;
    const twoColumnDropDowns = Array.from(document.querySelectorAll("#navbar-nav .show"));
    twoColumnDropDowns.forEach((node: any) => {
      node.classList.remove("show");
    });
    if (isTwoColumnMenu) {
      isTwoColumnMenu.classList.add("show");
    }

    const twoColumnUl = document.getElementById("two-column-menu");
    if (twoColumnUl) {
      const twoColumnIconItems = Array.from(twoColumnUl.getElementsByTagName("a"));
      const twoColumnActiveIconItems = twoColumnIconItems.filter((x: any) => x.classList.contains("active"));
      twoColumnActiveIconItems.forEach((item: any) => {
        item.classList.remove("active");
      });
    }
    event.target.classList.add("active");
    document.body.classList.remove("twocolumn-panel");
  }

  // remove active items of two-column-menu
  removeActivation(items: any): void {
    items.forEach((item: any) => {
      if (item.classList.contains("menu-link")) {
        if (!item.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        item.nextElementSibling.classList.remove("show");
      }
      if (item.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
        if (item.parentElement) {
          item.parentElement.closest(".collapse")?.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item.classList.remove("active");
    });
  }

  activateIconSidebarActive(id: any): void {
    const menu = document.querySelector(`#two-column-menu .simplebar-content-wrapper a[subitems='${id}'].nav-icon`);
    if (menu !== null) {
      menu.classList.add("active");
    }
  }

  activateTwoColumnParentDropdown(item: any): boolean {
    // navbar-nav menu add active
    item.classList.add("active");
    const twoColumnParentCollapseDiv = item.closest(".collapse.menu-dropdown");
    if (twoColumnParentCollapseDiv) {
      // to set aria expand true remaining
      twoColumnParentCollapseDiv.classList.add("show");
      twoColumnParentCollapseDiv.parentElement.children[0].classList.add("active");
      twoColumnParentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
      if (twoColumnParentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        twoColumnParentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
        if (twoColumnParentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
          twoColumnParentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
      }
      this.activateIconSidebarActive(twoColumnParentCollapseDiv.getAttribute("id"));
    }
    return false;
  }

  initActiveMenu(): void {
    const pathName = window.location.pathname;

    // Active Main Single Menu
    const mainItems = Array.from(document.querySelectorAll(".twocolumn-iconview li a"));
    const matchingMainMenuItem = mainItems.find((x: any) => {
      return x.pathname === pathName;
    });
    if (matchingMainMenuItem) {
      this.activateTwoColumnParentDropdown(matchingMainMenuItem);
    }

    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      const activeItems = items.filter((x: any) => x.classList.contains("active"));
      this.removeActivation(activeItems);

      const matchingMenuItem = items.find((x: any) => {
        return x.pathname === pathName;
      });

      if (matchingMenuItem) {
        this.activateTwoColumnParentDropdown(matchingMenuItem);
      } else {
        const id = pathName.replace("/", "");
        if (id) document.body.classList.add("twocolumn-panel");
        this.activateIconSidebarActive(id);
      }
    }
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasTwoColumnItems(item: MenuItem): boolean {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * SidebarHide modal
   * @param content modal content
   */
  twoColumnSidebarHide(): void {
    document.body.classList.remove("vertical-sidebar-enable");
  }

  twoColumnFilteredMenuItems(twoColumnMenuItems: MenuItem[]): MenuItem[] {
    return twoColumnMenuItems
      ? twoColumnMenuItems.filter((mainMenu) =>
          mainMenu.subItems
            ? this.twoColumnFilteredMenuItems(mainMenu.subItems).length
            : mainMenu.role === this.twoColumnDefaultMenu || this.authService.isMainAdminLogin || this.twoColumnPermissions?.some((x) => x.name === mainMenu.role)
        )
      : [];
  }
}
